import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Switch from "@material-ui/core/Switch";
import Compressor from "compressorjs";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import AerosDialog from "../AerosDialog";
import useAerosModalStyles from "../../styles/aerosModalStyles";
import useAerosSettingsStyles from "../Settings/aerosSettingsStyles";

const useStyles = makeStyles((theme) => ({
  dropzone: {
    border: `1px dashed ${theme.palette.type === "light" ? theme.palette.aeros.borderStrong : "rgba(255,255,255,0.15)"}`,
    borderRadius: 11,
    padding: 16,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    fontSize: 12,
    color: theme.palette.text.secondary,
    textAlign: "center",
  },
  chooseBtn: { borderRadius: 8, fontSize: 12, fontWeight: 600, padding: "4px 12px" },
  player: { width: "100%", maxWidth: 420 },
  fileName: { fontSize: 12, color: theme.palette.text.primary, wordBreak: "break-all" },
}));

const FlowBuilderAddAudioModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStyles();
  const m = useAerosModalStyles();
  const aeros = useAerosSettingsStyles();
  const [activeModal, setActiveModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [record, setRecord] = useState(false);
  const [preview, setPreview] = useState();
  const [medias, setMedias] = useState([]);

  useEffect(() => {
    if (open === "edit") {
      setPreview(process.env.REACT_APP_BACKEND_URL + "/public/" + data.data.url);
      setRecord(data.data.record);
      setActiveModal(true);
    } else if (open === "create") {
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
    setMedias([]);
    setPreview();
  };

  const handleSaveContact = async () => {
    if (open === "edit") {
      handleClose();
      onUpdate({
        ...data,
        data: { url: data.data.url, record: record },
      });
      return;
    } else if (open === "create") {
      setLoading(true);
      const formData = new FormData();
      formData.append("fromMe", true);

      medias.forEach(async (media) => {
        const file = media;

        if (!file) {
          return;
        }

        if (media?.type.split("/")[0] === "image") {
          new Compressor(file, {
            quality: 0.7,

            async success(media) {
              formData.append("medias", media);
              formData.append("body", media.name);
            },
            error(err) {
              alert("erro");
              console.log(err.message);
            },
          });
        } else {
          formData.append("medias", media);
          formData.append("body", media.name);
        }
      });

      setTimeout(async () => {
        await api.post("/flowbuilder/audio", formData).then((res) => {
          handleClose();
          onSave({
            url: res.data.name,
            record: record,
          });
          toast.success(i18n.t("aeros.flow.modals.audio.success"));
          setLoading(false);
        });
      }, 1000);
    }
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 5000000) {
      toast.error(i18n.t("aeros.flow.modals.audio.tooLarge"));
      return;
    }

    const selectedMedias = Array.from(e.target.files);
    setPreview(URL.createObjectURL(e.target.files[0]));
    setMedias(selectedMedias);
  };

  return (
    <AerosDialog
      open={activeModal}
      onClose={handleClose}
      width={560}
      title={i18n.t(open === "edit" ? "aeros.flow.modals.audio.editTitle" : "aeros.flow.modals.audio.addTitle")}
      onSubmit={handleSaveContact}
      submitLabel={i18n.t(open === "edit" ? "aeros.flow.save" : "aeros.flow.add")}
      submitDisabled={open !== "edit" && medias.length === 0}
      loading={loading}
    >
      <div>
        <label className={m.fieldLabel}>{i18n.t("aeros.flow.nodes.audio")}</label>
        <div className={classes.dropzone}>
          {preview && (
            <audio controls="controls" className={classes.player}>
              <source src={preview} type="audio/mp3" />
              {i18n.t("aeros.flow.modals.audio.noHtml5")}
            </audio>
          )}
          {open !== "edit" && (
            <>
              <Button variant="outlined" component="label" size="small" className={classes.chooseBtn} disabled={loading}>
                {i18n.t("aeros.flow.content.chooseFile")}
                <input type="file" accept="audio/ogg, audio/mp3" disabled={loading} hidden onChange={handleChangeMedias} />
              </Button>
              {medias[0] ? (
                <span className={classes.fileName}>{medias[0].name}</span>
              ) : (
                <span>{i18n.t("aeros.flow.modals.audio.dropHint")}</span>
              )}
            </>
          )}
        </div>
      </div>
      {preview && (
        <div className={m.optionBox}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className={m.optionTitle}>{i18n.t("aeros.flow.content.recordedNow")}</div>
            <div className={m.optionDesc}>{i18n.t("aeros.flow.modals.audio.recordedNowDesc")}</div>
          </div>
          <Switch
            className={aeros.toggleSwitchSmall}
            color="primary"
            checked={!!record}
            onChange={(e) => setRecord(e.target.checked)}
            inputProps={{ "aria-label": i18n.t("aeros.flow.content.recordedNow") }}
          />
        </div>
      )}
    </AerosDialog>
  );
};

export default FlowBuilderAddAudioModal;
